import React, {Component} from "react";
import './home.scss'
import {Link} from 'react-router-dom';
import axios from 'axios';
import Loader from "../loader";
import {API_URL} from '../env'

class Home extends Component {
    constructor() {
        super();
        this.state = {
            loading: false
        };
    }

    startParsingResumes = () => {
        this.setState({loading: true});
        axios.get(`${API_URL.url}/extractTags`)
            .then((resp) => {
                this.setState({loading: false})
                alert("Resumes Parsed Successfully")
            })
            .catch((error) => {
                this.setState({loading: false})
                alert('Resumes Parsing Failed. Please Try Again');
            })
    }

    render() {
        const messageOne = 'Please Wait...'
        const messageTwo = 'Parsing Resumes'
        return (
            <div>
                {
                    this.state.loading ? <Loader messageOne={messageOne} messageTwo={messageTwo}/> : null
                }
                <div className="home-page">
                    <div className="home-title">Match Making 2.0</div>
                    <div className="home-page-container">
                        <Link className="home-page-options" to="/analyzed-jd">
                            JDs
                        </Link>
                        <Link className="home-page-options" to="/analyzed-resumes">
                            Resumes
                        </Link>
                        <Link className="home-page-options" to="/post-requirement">
                            Match Making
                        </Link>
                    </div>
                </div>
            </div>
        )
    }
}

export default Home
